import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { labels } from 'src/app/constants/labels.constants';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'terms-confirmation-dialog',
  templateUrl: './terms-dialog.component.html',
  styleUrls: ['./terms-dialog.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    MatButton,
    FormsModule,
    MatCheckboxModule,
    CommonModule
    
  ],
})
export class TermsConfirmationDialogComponent {

  constructor(
     public commonService: CommonService,
    public dialogRef: MatDialogRef<TermsConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
    
  ) {
    
  }
  
  isSecurityPledgeCheck=false; 
  privacyNoticeText = labels['securityPledges'][this.commonService.getNavigatorLang()]
  agreementStatement =  labels['agreementStatement'][this.commonService.getNavigatorLang()]
  submitTermsAndConditions() {
    const userId = this.commonService.username
    this.commonService.updateSecurityPledgeSign({ "user_id":userId }).subscribe(
      (res: any) => { 
        this.dialogRef.close();
      },
      (error:any) => {
        console.log("error: ", error)
      }
    );
  }
}